import { ERROR_MESSAGES } from '@/shared/constants/error-messages';
import { passwordValidation, Phone, PhoneAndRequired } from '@/shared/helpers/validations';
import * as Yup from 'yup';

// Create the custom validation method for caregiverPhone
const ConditionalPhoneAndRequired = (schema: Yup.StringSchema) => {
    return schema.test('required-if-invite', function (value) {
        const { inviteACaregiver } = this.parent;
        const { path, createError } = this;

        if (inviteACaregiver) {
            if (!value) {
                return createError({ path, message: ERROR_MESSAGES.REQUIRED_FIELD_MISSING });
            }

            if (!Phone(Yup.string()).isValidSync(value)) {
                return createError({ path, message: ERROR_MESSAGES.INVALID_PHONE_NUMBER });
            }
        }

        return true;
    });
};

const unsupportedEmailProviders = ['icloud.com', 'mac.com', 'me.com'];

export const registerValidation = Yup.object({
    email: Yup.string()
        .required(ERROR_MESSAGES.REQUIRED_FIELD_MISSING)
        .email(ERROR_MESSAGES.VALID_EMAIL)
        .test(
            'unsupported-email-provider',
            "Sorry, we're unable to send emails to addresses from your email provider. Please use a different email address to continue.",
            value => {
                if (value) {
                    const domain = value.split('@')[1];
                    return !unsupportedEmailProviders.includes(domain);
                }
                return true;
            }
        ),
    phoneNumber: PhoneAndRequired(Yup.string()),
    password: passwordValidation,
    inviteACaregiver: Yup.boolean(),
    relationship: Yup.string().test('required-if-invite', ERROR_MESSAGES.REQUIRED_FIELD_MISSING, function (value) {
        const { inviteACaregiver } = this.parent;
        return !inviteACaregiver || !!value;
    }),
    caregiverFirstName: Yup.string().test('required-if-invite', ERROR_MESSAGES.REQUIRED_FIELD_MISSING, function (value) {
        const { inviteACaregiver } = this.parent;
        return !inviteACaregiver || !!value;
    }),
    caregiverLastName: Yup.string().test('required-if-invite', ERROR_MESSAGES.REQUIRED_FIELD_MISSING, function (value) {
        const { inviteACaregiver } = this.parent;
        return !inviteACaregiver || !!value;
    }),
    caregiverEmail: Yup.string()
        .email(ERROR_MESSAGES.VALID_EMAIL)
        .test('required-if-invite', ERROR_MESSAGES.REQUIRED_FIELD_MISSING, function (value) {
            const { inviteACaregiver } = this.parent;
            return !inviteACaregiver || !!value;
        }),
    caregiverPhone: ConditionalPhoneAndRequired(Yup.string())
});
